import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15
const userUri = config.apiEndpoints.usersUri
export default {
    findAll: (keywords, businessType, page) => {
        return new Promise((resolve, reject) => {            
            HTTP.get(`${userUri}search?keywords=${keywords}&pageSize=${pageSize}&page=${page}&businessType=${businessType}` ).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: (keywords, businessType) => {
        return new Promise((resolve, reject) => {
            HTTP.get(userUri.concat(`?keywords=${keywords}&businessType=${businessType}`)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },    
    find: (userId) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(userUri.concat(userId)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },    
    createUser: (request) => {
        return new Promise((resolve, reject) => {
            HTTP.post(userUri, request).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    updateUser: (request) => {
        return new Promise((resolve, reject) => {
            HTTP.put(userUri, request).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
}